import { render, staticRenderFns } from "./multiplayer-landing-pages.vue?vue&type=template&id=51b36e30&"
import script from "./multiplayer-landing-pages.vue?vue&type=script&lang=js&"
export * from "./multiplayer-landing-pages.vue?vue&type=script&lang=js&"
import style0 from "./multiplayer-landing-pages.vue?vue&type=style&index=0&id=51b36e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports